export default __webpack_public_path__ + "static/media/tangerine-logo.500a214d.svg";